
/**
 * @typedef {'AUTH_EXPIRED'|'VALIDATION_ERROR'|'NOT_FOUND'|'SERVER_ERROR'|'NETWORK_ERROR'|'REQUEST_ERROR'} ApiErrorType
 * @typedef {{ type: ApiErrorType, status: number | null, message: string, errors?: Record<string, any>, raw?: any }} NormalizedApiError
 */

/** @param {any} error */
export const normalizeApiError = (error) => {
  if (error?.isNormalizedApiError) return error;

  const status = error?.response?.status ?? null;
  const data = error?.response?.data;
  const message =
    data?.message ||
    data?.msg ||
    error?.message ||
    "Something went wrong. Please try again.";

  /** @type {ApiErrorType} */
  let type = "REQUEST_ERROR";
  if (status === 401) type = "AUTH_EXPIRED";
  else if (status === 400 || status === 422) type = "VALIDATION_ERROR";
  else if (status === 404) type = "NOT_FOUND";
  else if (status && status >= 500) type = "SERVER_ERROR";
  else if (!status) type = "NETWORK_ERROR";

  return {
    isNormalizedApiError: true,
    type,
    status,
    message,
    errors: data?.errors,
    response: error?.response,
    raw: error,
  };
};
